import React,{ useState }from 'react';
import styled from 'styled-components'
import Checkbox from './CheckBox';
import NormalText from './NormalText';
import CircleNumber from './CircleNumber';
import { media } from '../styles/Mixin';




const SelectBox = ({
  data,
  saveInfo,
  setSaveInfo,
  comment,
  topCommentData,
  deleteInfo,
  setDeleteInfo
}) => {
  const [originArray, setOriginArray] = useState([]);
  
  const checkedFn = () => {
    /**
     * 여기서 topComment를 이용해서 찾지 않으면 saveTopComment mutation할경우 cache가 update되지 않는 것 같다.
     */

      const selectedCommentId = comment.snippet? comment.snippet.topLevelComment.id : comment.topCommentId
      const selectedCategoryId = data.id
      const boolean = topCommentData.seeRequestUserTopComment.map((comment)=>{
        if(comment.topCommentId === selectedCommentId && comment.category.id === selectedCategoryId){
          return true
        }else{
          return false
        }
      })
      if (boolean.indexOf(true) !== -1) {
        setOriginArray([...originArray, data.id]);
        return true;
      }else{
        return false
      }
  };

  const [checked, setChecked] = useState(checkedFn);
  const checkBoxClick = () => {
    /**
     * original 과 비교해서 check할때는 saveInfo 에서 해당 category id가 없을경우 categoryid추가
     * original 과 비교해서 check안할때는 deleteInfo에서 해당 category id가 있을경우만  category id 추가
     */
    setChecked(!checked);
    if(!checked){
      if(originArray.indexOf(data.id) === -1){
        setSaveInfo([...saveInfo,data.id])
      }
      const array = deleteInfo
      const findIndex = array.indexOf(data.id)
      if (findIndex !== -1) {
        array.splice(findIndex, 1);
        setDeleteInfo(array)
      }
    }else{
      if(originArray.indexOf(data.id) !== -1){
        setDeleteInfo([...deleteInfo, data.id]);
      }
      const array = saveInfo
      const findIndex = array.indexOf(data.id)
      if (findIndex !== -1){
        array.splice(findIndex,1);
        setSaveInfo(array)
      }

    }
  }

  return (
    /**
     * commentId
     * 존재하는지
     */
    <Wrapper>
      <CheckSquareBox>
        <Checkbox checked={checked} onClick={checkBoxClick} size={"sm"} />
      </CheckSquareBox>
      <CategoryNameBox>
        <NormalText text={data.categoryName} />
      </CategoryNameBox>
      <CategoryCountBox>
        <CustomCircleNumber number={data.categoryCount} />
      </CategoryCountBox>
    </Wrapper>
  );
};

export default SelectBox;



const Wrapper = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:flex-start;
    &>:not(:last-child){
        ${media.deskTop`
            margin-right:20px;
        `}
        ${media.mobile`
            margin-right:10px;
        `} 
    }
`

const CheckSquareBox = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
`

const CategoryNameBox = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
`

const CategoryCountBox = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
`

const CustomCircleNumber = styled(CircleNumber)`
 ${media.deskTop`
    width:25px;
    height:25px;
    font-size:${(props) => props.theme.deskFontSize};
  `}
${media.mobile`
    width:20px;
    height:20px;
    font-size:${(props) => props.theme.mobileFontSize};
  `}
`